import React from 'react'
import { Toaster } from 'react-hot-toast'
import idleManager from 'react-idle-manager'
import { connect } from 'react-redux'
import { Link, Outlet } from 'react-router-dom'
import { bindActionCreators } from 'redux'

import Logo from '../assets/svgs/lucent-logo.svg?component'
import { withLegacyRouter } from '../decorators'
import { GlobalDiscardDialog, withDiscardDialog } from '../lib/global-discard-dialog'
import { getGlobalVars } from '../lib/GlobalVars/actions'
import { startPubsubListening, stopPubsubListening } from '../lib/pubsub'

import { CommitSetter } from './commit-setter'
import { GlobalLoadingIndicator } from './global-loading-indicator'
import { logout } from './LoginForm/actions'
import { NavigationSetter } from './navigation'
import { getHistory } from './NotificationsHistory/actions'
import { Previewer } from './previewer'
import { ScrollTop } from './scroll-top'
import * as NarusMaterial from './shared/NarusMaterial'
import { ToastStack } from './shared/toast-stack'
import { Version } from './shared/version'

const IDLE_TIMEOUT = 1000 * 60 * 60
const IDLE_MANAGER_OPTIONS = {
  key: 'compassion',
  idleAfter: IDLE_TIMEOUT,
  isPure: false,
  timeoutAfter: IDLE_TIMEOUT
}

const mapStateToProps = redux => ({
  app: redux.app,
  auth: redux.auth,
  notification: redux.notification,
  globalVars: redux.globalVars
})

const mapDispatchToProps = dispatch => bindActionCreators({
  getGlobalVars,
  getHistory,
  logout
}, dispatch)

@withLegacyRouter
@withDiscardDialog
@idleManager(IDLE_MANAGER_OPTIONS)
class IdleManager extends React.Component {
  componentDidUpdate (prevProps, prevState) {
    if (this.props.isIdle) {
      this.props.logout(
        this.props.discardDialog
      )
    }
  }

  render () {
    return this.props.children
  }
}

@withLegacyRouter
@connect(mapStateToProps, mapDispatchToProps)
export default class App extends React.Component {
  constructor (props) {
    super(props)

    this.state = {
      startedListening: false
    }
  }

  componentDidMount () {
    this.props.getGlobalVars()
    this.props.getHistory()

    try {
      startPubsubListening()
    } catch (err) {
      // This is probably only relevant for local development environments
      // because in React.StrictMode components are mounted twice during
      // development.
      if (err !== 'Only 1 shared subscriber allowed per url per window/tab.') {
        throw err
      }
    }
  }

  // componentDidUpdate (prevProps, prevState) {

  // }

  componentWillUnmount () {
    stopPubsubListening()
  }

  render () {
    if (!this.props.globalVars || this.props.globalVars.loading) {
      return (
        <NarusMaterial.CircularProgress />
      )
    }

    const {
      auth: { profile },
      globalVars: { params }
    } = this.props

    const patientId = params ? params.id : false

    if (!profile) {
      return (
        <NarusMaterial.CircularProgress />
      )
    }

    return (
      <>
        <ScrollTop />
        <NavigationSetter />
        <Previewer />
        <CommitSetter />

        <GlobalDiscardDialog>
          <IdleManager logout={this.props.logout}>
            <NarusMaterial.NavBar
              logo={(
                <Link
                  to='/'
                  title='Dashboard'
                >
                  <Logo className='w-8' />
                </Link>
              )}
              noShadow={!!patientId}
            />
            <Outlet />
            <Version
              className='text-right'
              align='right'
            />
            <ToastStack />

            <Toaster
              position='bottom-right'
              containerClassName='tailwind'
              toastOptions={{
                className: 'default-toast',
                duration: 15_000
              }}
            />

            <GlobalLoadingIndicator />
          </IdleManager>
        </GlobalDiscardDialog>
      </>
    )
  }
}
